"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const signals_1 = require("signals");
const Stage_1 = __importDefault(require("./three/Stage"));
const ChapterManager_1 = __importDefault(require("./chapter/ChapterManager"));
const SentenceManager_1 = __importDefault(require("./SentenceManager"));
const ImageLoader_1 = __importDefault(require("./ImageLoader"));
const Header_1 = __importDefault(require("./Header"));
const IndicatorManager_1 = __importDefault(require("./IndicatorManager"));
(function () {
    const signals = {
        start: new signals_1.Signal(),
        loadedImage: new signals_1.Signal(),
        showText: new signals_1.Signal(),
        hideText: new signals_1.Signal(),
        textBlack: new signals_1.Signal(),
        textWhite: new signals_1.Signal(),
        readyNextChapter: new signals_1.Signal(),
        nextChapter: new signals_1.Signal(),
        hideIndicatorText: new signals_1.Signal(),
        hideAbout: new signals_1.Signal(),
        showHeader: new signals_1.Signal(),
    };
    const stage = new Stage_1.default({
        container: document.querySelector('#container'),
        production: true,
    });
    const chapterManager = new ChapterManager_1.default(stage, signals);
    new SentenceManager_1.default(signals);
    const indicatorManager = new IndicatorManager_1.default(stage, signals);
    new Header_1.default(signals);
    const imageLoader = new ImageLoader_1.default();
    function loop(time) {
        stage.update();
        indicatorManager.update();
        chapterManager.update(time);
        requestAnimationFrame(loop);
    }
    function load(key) {
        imageLoader.load(stage.cache).then(() => {
            imageLoader.hideView();
            chapterManager.init(stage);
            gsap_1.gsap.delayedCall(0.4, () => start(key));
        });
    }
    function start(key) {
        chapterManager.start(key);
        loop(0);
    }
    function getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' +
            encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') +
            '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
    }
    const key = getQueryStringValue('key') ? getQueryStringValue('key') : 'intro';
    load(key);
})();
